import { defineStore } from "pinia";

export const useLanguageStore = defineStore("language", {
  state: () => ({
    language: JSON.parse(localStorage.getItem("selectedLanguage") || '{"name": "AR", "value": "ar"}'),
    direction: "rtl", // Default direction based on the initial language
  }),
  actions: {
    // Update language and direction in the store
    setLanguage(language: { name: string; value: string }) {
      this.language = language;
      this.direction = language.value === "en" ? "ltr" : "rtl";

      // Update HTML attributes
      document.documentElement.setAttribute("dir", this.direction);
      document.documentElement.setAttribute("lang", language.value);

      // Save the selected language to localStorage
      localStorage.setItem("selectedLanguage", JSON.stringify(language));
    },
  },
});
